import React, { useEffect, useState } from "react";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";
import DashboardCard from "../../Layouts/DashboardCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Typography,
  Breadcrumbs,
  Button,
  AppBar,
  Toolbar,
  Tooltip,
  IconButton,
  Menu,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Checkbox, InputAdornment, ListItemText } from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router";
import OnlineUserReportTable from "../../Layouts/OrderSummariesTables/OnlineUserReport";
import OngoingOrdersTable from "../../Layouts/OrderSummariesTables/OngoingOrderReports";
import AllOrderAndBroadcastTable from "../../Layouts/OrderSummariesTables/AllOrderAndBroadcastReports";
import { OrderSummaryApi } from "../../../API/OrderSummaries";
import Logout from "@mui/icons-material/Logout";
import "./style.css";
import { OrderOnDemandApi } from "../../../API/ZyppIt";
import OrderTimeStampTable from "../../Layouts/OrderSummariesTables/OrderTimeStampReport";

function OrderSummaries() {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [selectedCity, setSelectedCity] = useState<any>("GGN");
  const [localityKeys, setLocalityKeys] = useState<string[]>(["kherla"]);
  const [selectedLocalityID, setSelectedLocalityID] = useState<string[]>([
    "11",
  ]);
  const [selectAll, setSelectAll] = useState(false);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    let selectedValues = typeof value === "string" ? value.split(",") : value;

    // Toggle "Select All" / "Unselect All"
    if (selectedValues.includes("All Localities")) {
      if (!selectAll) {
        const allLocalities = localityData
          .filter((locality: any) => locality.city === selectedCity)
          .map((locality: any) => locality.locality);
        const allLocalityIds = localityData
          .filter((locality: any) => locality.city === selectedCity)
          .map((locality: any) => locality.polygonId);
        setLocalityKeys(allLocalities);
        setSelectedLocalityID(allLocalityIds);
        setSelectAll(true); // Update state to reflect "All" are selected
      } else {
        // If all are currently selected, unselect all
        setLocalityKeys([]);
        setSelectedLocalityID([]);
        setSelectAll(false);
      }
    } else {
      // Handle individual locality selection
      const selectedLocalityIds = localityData
        .filter((locality: any) => selectedValues.includes(locality.locality))
        .map((locality: any) => locality.polygonId);
      setLocalityKeys(selectedValues);
      setSelectedLocalityID(selectedLocalityIds);
      // If not all localities are selected, ensure "selectAll" is false
      setSelectAll(
        selectedValues.length ===
          localityData.filter((locality: any) => locality.city === selectedCity)
            .length
      );
    }
  };

  const [localityData, setLocalityData] = useState<any>([]);
  const [orderCardDetails, setOrderCardDetails] = useState<any>([]);
  const [selectedLocality, setSelectedLocality] = useState<any>("-1");
  const [cityData, setCityData] = useState<any>([]);
  const [merchantData, setMerchantData] = useState<any>([]);
  const [selectedMerchant, setSelectedMerchant] = useState<any>(-1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState(true);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  const [defaultStartDate, defaultEndDate] = getDefaultDateRange();
  const [dateRange, setDateRange] = useState([
    defaultStartDate,
    defaultEndDate,
  ]);
  function getDefaultDateRange() {
    const today = new Date();
    const lastWeekStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 6
    );
    const lastWeekEnd = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    return [lastWeekStart, lastWeekEnd];
  }

  useEffect(() => {
    OrderSummaryApi.api
      .localityListApi()
      .then((e) => {
        setLocalityData(e.bifurcations);
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
    OrderSummaryApi.api
      .cityListApi()
      .then((e) => {
        setCityData(e.bifurcations);
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, []);
  useEffect(() => {
    setLoading(true);
    if (dateRange[0] && dateRange[1]) {
      OrderSummaryApi.api
        .orderCardDetails(
          selectedMerchant,
          formatDate(dateRange[0]),
          formatDate(dateRange[1]),
          selectedLocalityID
        )
        .then((e) => {
          setOrderCardDetails(e.bifurcations.data[0]);
          setLoading(false);
        })
        .catch((error) => {
          console.error("API call error: ", error);
          setLoading(false);
        });
    }
  }, [dateRange, selectedLocalityID, selectedMerchant]);
  useEffect(() => {
    const api = new OrderOnDemandApi();
    api
      .merchantList()
      .then((e) => {
        setMerchantData(e.data.data);
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, []);
  const formatDate = (date: Date | undefined) => {
    if (!date) return undefined;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  function formatGMV(amount: any) {
    if (amount == null) {
      return "N/A"; // Handle null or undefined values
    }
    if (amount >= 10000000) {
      return `${(amount / 10000000).toFixed(1)} Cr`; // Crores
    } else if (amount >= 100000) {
      return `${(amount / 100000).toFixed(1)} Lakhs`; // Lakhs
    } else if (amount >= 1000) {
      return `${(amount / 1000).toFixed(1)}k`; // Thousands
    } else {
      return amount.toString(); // Less than thousand
    }
  }
  return (
    <>
      <div className="flex">
        <div className="w-1/6 mr-3 ml-3">
          <SideBarNavigation />
        </div>
        <div className="w-5/6">
          <div className="pb-4 pr-4 pl-2 mt-6">
            <AppBar
              position="static"
              style={{
                background: "#ffffff",
                boxShadow: "none",
                width: "100%",
              }}
            >
              <Toolbar
                className="justify-between"
                sx={{ "&&": { padding: 0, minHeight: 0 } }}
              >
                <div className="flex items-center">
                  {/* <div className="flex flex-col items-center">
            {merchantLogoUrl && merchantLogoUrl !== "" ? (
              <div>
                <img src={merchantLogoUrl} alt="Logo" className="h-20 w-20" />
              </div>
            ) : (
              <div>
                {" "}
                <img
                  src="/assets/icons/zyppItLogo.png"
                  alt="zyppIt Logo"
                />{" "}
              </div>
            )}
          </div> */}
                </div>
                <div className="flex items-center">
                  <Typography className="text-black pr-1">
                    Date Range:
                  </Typography>
                  <div className="border-[2.5px] rounded-md">
                    <div className="">
                      <DatePicker
                        selectsRange={true}
                        className="text-black text-sm p-1"
                        startDate={dateRange[0]}
                        endDate={dateRange[1]}
                        maxDate={new Date()}
                        dateFormat="yyyy/MM/dd"
                        onChange={(update: any) => {
                          setDateRange(update);
                        }}
                      />
                    </div>
                  </div>
                  <Tooltip title="Logout">
                    <IconButton
                      onClick={handleLogout}
                      size="small"
                      aria-controls={open ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <Logout color="success" fontSize="large" />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                  ></Menu>
                </div>
              </Toolbar>
            </AppBar>{" "}
            <div className="flex justify-between mt-8 ml-6">
              <div className="font-medium text-left text-[32px] text-[#1E1E1E] font-inter">
                Order Summary
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  sx={{ mt: 4 }}
                >
                  <Typography
                    color="#ACACAC"
                    sx={{ fontSize: "12px", fontWeight: "500" }}
                  >
                    Dashboard
                  </Typography>
                  <Typography
                    color="#717171"
                    sx={{ fontSize: "12px", fontWeight: "700" }}
                  >
                    Order Summary
                  </Typography>
                </Breadcrumbs>
              </div>
              <div className="">
                <div className="flex">
                  <div className="border-2 flex rounded-3xl flex items-center mr-3 px-1">
                    <label className="text-[#727597] items-center text-sm font-normal font-inter">
                      Merchant :
                    </label>
                    <select
                      name="locality"
                      id="locality"
                      className="text-[#727597] text-sm font-normal font-inter p-2 min-w-[100px]"
                      value={selectedMerchant}
                      onChange={(e) => {
                        setSelectedMerchant(e.target.value);
                      }}
                    >
                      <option value={-1}>All</option>
                      {merchantData?.map((merchant: any) => (
                        <option
                          key={merchant.merchantId}
                          value={merchant.merchantId}
                        >
                          {merchant.merchantName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="border-2 flex rounded-3xl flex items-center mr-3 px-1">
                    <label className="text-[#727597] items-center text-sm font-normal font-inter">
                      City:
                    </label>
                    <select
                      name="locality"
                      id="locality"
                      className="text-[#727597] text-sm font-normal font-inter p-2 min-w-[100px]"
                      value={selectedCity}
                      onChange={(e) => {
                        setSelectedCity(e.target.value);
                        setSelectAll(false);
                        setLocalityKeys([]); // Clear the selected localities
                      }}
                    >
                      {cityData.map((city: any) => (
                        <option key={city.city_code} value={city.city_code}>
                          {city.city_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <FormControl sx={{ border: "none", width: 300 }}>
                    <Select
                      multiple
                      displayEmpty
                      value={localityKeys}
                      onChange={handleChange}
                      input={
                        <OutlinedInput
                          sx={{ borderRadius: "50px", borderWidth: "2px" }}
                          startAdornment={
                            <label className="text-[#727597] text-sm font-normal font-inter mr-2">
                              Locality:
                            </label>
                          }
                          size="small"
                        />
                      }
                      renderValue={(selected) => {
                        return selected.join(", ");
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="All Localities">
                        <Checkbox
                          checked={
                            selectAll ||
                            localityKeys.length ===
                              localityData.filter(
                                (locality: any) =>
                                  locality.city === selectedCity
                              ).length
                          }
                        />
                        <ListItemText
                          primary={selectAll ? "Unselect All" : "Select All"}
                        />
                      </MenuItem>

                      {localityData.filter(
                        (locality: any) => locality.city === selectedCity
                      ).length === 0 ? (
                        <MenuItem value="-1" disabled>
                          No Localities Available
                        </MenuItem>
                      ) : (
                        localityData
                          .filter(
                            (locality: any) => locality.city === selectedCity
                          )
                          .map((locality: any) => (
                            <MenuItem
                              key={locality.polygonId}
                              value={locality.locality}
                            >
                              <Checkbox
                                checked={localityKeys.includes(
                                  locality.locality
                                )}
                              />
                              <ListItemText primary={locality.locality} />
                            </MenuItem>
                          ))
                      )}
                    </Select>
                  </FormControl>
                </div>
                {/* <Button
                  className="mb-2"
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    px: 2,
                    mb: 2,
                    bgcolor: "#0079FF",
                    "&:hover": { bgcolor: "#0077F" },
                    fontSize: "18px",
                    borderRadius: "30px",
                  }}
                  onClick={handleCreateOrder}
                >
                  <img
                    src="/assets/icons/whitePlusIcon.svg"
                    alt=""
                    className="mr-2"
                  />
                  Create Order
                </Button> */}
              </div>
            </div>
          </div>
          <div className="flex mb-1 ml-6 justify-between pr-2">
            <div className="w-full mr-2">
              <DashboardCard
                heading="Total Placed Orders"
                backgroundColor="#21316F33"
                data={orderCardDetails?.placed_orders || "--"}
                comparison="50"
                imgSrc="/assets/icons/greyBagIcon.svg"
                increment={false}
                loading={loading}
              />
            </div>
            <div className="w-full mr-2">
              <DashboardCard
                heading="Total Delivered Orders"
                backgroundColor="#00CB6033"
                data={orderCardDetails?.delivered_counts || "--"}
                comparison="50"
                imgSrc="/assets/icons/bagIcon.svg"
                increment={true}
                loading={loading}
              />
            </div>
            <div className="w-full mr-2">
              <DashboardCard
                heading="Total Cancelled Orders"
                backgroundColor="#F9493233"
                data={orderCardDetails?.cancelled_counts || "--"}
                comparison="50"
                imgSrc="/assets/icons/redBagIcon.svg"
                increment={false}
                loading={loading}
              />
            </div>
            <div className="w-full mr-2">
              <DashboardCard
                heading="Total Returned Orders"
                backgroundColor="#171F2133"
                data={orderCardDetails?.returned_order_counts || "--"}
                comparison="50"
                imgSrc="/assets/icons/blackBagIcon.svg"
                increment={true}
                loading={loading}
              />
            </div>
            <div className="w-full mr-2">
              <DashboardCard
                heading="Total Pending Orders"
                backgroundColor="#FFB84633"
                data={orderCardDetails?.pending_counts || "--"}
                comparison="50"
                imgSrc="/assets/icons/yellowBagIcon.svg"
                increment={false}
                loading={loading}
              />
            </div>
          </div>
          <div className="flex mb-3 ml-6 justify-center pr-2">
            <div className="flex w-5/6">
              <div className="w-full mr-2">
                <DashboardCard
                  heading="Total Fulfilled %"
                  backgroundColor="#8B97FF33"
                  data={`${
                    orderCardDetails?.fulfilled_percentage !== undefined
                      ? orderCardDetails?.fulfilled_percentage + " %"
                      : "--"
                  }`}
                  comparison="50"
                  imgSrc="/assets/icons/lavenderBagIcon.svg"
                  increment={false}
                  loading={loading}
                />
              </div>
              <div className="w-full mr-2">
                <DashboardCard
                  heading="Cancelled After Assignment"
                  backgroundColor="#FF950033"
                  data={orderCardDetails?.cancelled_after_assignment || "--"}
                  comparison="50"
                  imgSrc="/assets/icons/cancelledAfterAssignment.svg"
                  increment={false}
                  loading={loading}
                />
              </div>
              <div className="w-full mr-2">
                <DashboardCard
                  heading="Order Cancelled in 60s"
                  backgroundColor="#D02A0033"
                  data={
                    orderCardDetails?.cancelled_within_sixty_seconds || "--"
                  }
                  comparison="50"
                  imgSrc="/assets/icons/orderCancelledIcon.svg"
                  increment={false}
                  loading={loading}
                />
              </div>
              <div className="w-full mr-2">
                <DashboardCard
                  heading="Total GMV"
                  backgroundColor="#00875E33"
                  data={`${
                    formatGMV(orderCardDetails?.total_gmv_amount) !== "N/A"
                      ? "₹ " + formatGMV(orderCardDetails?.total_gmv_amount)
                      : "--"
                  }`}
                  comparison="50"
                  imgSrc="/assets/icons/gmvIcon.svg"
                  increment={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
          <div
            className="ml-6 mb-4 w-[96%]"
            style={{
              boxShadow: "0px 7px 29px 0px #64646F33",
              borderRadius: "8px",
            }}
          >
            <OngoingOrdersTable
              selectedLocality={selectedLocalityID}
              startDate={formatDate(dateRange[0])}
              endDate={formatDate(dateRange[1])}
              selectedMerchant={selectedMerchant}
            />
          </div>
          <div
            className="ml-6 mb-4 w-[96%]"
            style={{
              boxShadow: "0px 7px 29px 0px #64646F33",
              borderRadius: "8px",
            }}
          >
            <OnlineUserReportTable />
          </div>
          <div
            className="ml-6 mb-4 w-[96%]"
            style={{
              boxShadow: "0px 7px 29px 0px #64646F33",
              borderRadius: "8px",
            }}
          >
            <AllOrderAndBroadcastTable
              selectedLocality={selectedLocalityID}
              startDate={formatDate(dateRange[0])}
              endDate={formatDate(dateRange[1])}
              selectedMerchant={selectedMerchant}
            />
          </div>
          <div
            className="ml-6 mb-4 w-[96%]"
            style={{
              boxShadow: "0px 7px 29px 0px #64646F33",
              borderRadius: "8px",
            }}
          >
            <OrderTimeStampTable
              selectedLocality={selectedLocalityID}
              startDate={formatDate(dateRange[0])}
              endDate={formatDate(dateRange[1])}
              selectedMerchant={selectedMerchant}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderSummaries;
